// extracted by mini-css-extract-plugin
export var primitiveLabel = "_va-0";